import { takeEvery } from 'redux-saga/effects';

import { createSecretSuccess } from '@/modules/secrets/services/actions';

import { useReviewPrizepoolStore } from './store';

function* worker() {
    yield useReviewPrizepoolStore.getState().markQualifyingAction();
}

export function* saga() {
    yield takeEvery(createSecretSuccess.toString(), worker);
}
